import { render, staticRenderFns } from "./playerarea.vue?vue&type=template&id=e4b1350e&scoped=true"
import script from "./playerarea.vue?vue&type=script&lang=js"
export * from "./playerarea.vue?vue&type=script&lang=js"
import style0 from "./playerarea.vue?vue&type=style&index=0&id=e4b1350e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b1350e",
  null
  
)

export default component.exports